import React, { useState } from "react";
import { Container, Box, Alert } from "@mui/material";
import UserProfile from "../parts/UserProfile";
import ToggleTab from "../../shared/ToggleTab";
import ProjectRequestDetail from "../parts/ProjectRequestDetail";

const UserContractRequestPage = ({
  userContractRequestInfo,
  userContractRequest,
  flashMessage,
  priorities,
  jobRecruitingFlag,
}) => {
  const [showFlash] = useState(!!flashMessage);

  return (
    <>
      {showFlash && flashMessage && (
        <Box sx={{ px: 2, py: 1 }}>
          <Alert
            severity={
              typeof flashMessage === "object" ? flashMessage.type : "success"
            }
          >
            {typeof flashMessage === "object"
              ? flashMessage.message
              : flashMessage}
          </Alert>
        </Box>
      )}

      <Box sx={{ bgcolor: "white" }}>
        {/* プロフィール */}
        <UserProfile
          userContractRequestInfo={userContractRequestInfo}
          viewerType="user"
        />

        {/* 切り替えボタン */}
        <ToggleTab
          tabs={[
            {
              label: "プロジェクト募集",
              href: "/user_contract_request",
              isActive: (path) => path.includes("user_contract_request"),
            },
            {
              label: "転職先募集",
              href: "/user_job_request",
              isActive: (path) => path.includes("user_job_request"),
            },
          ]}
        />
      </Box>

      <Container maxWidth="md" sx={{ my: 5 }}>
        {/* 募集要項 */}
        <ProjectRequestDetail
          userContractRequestInfo={userContractRequestInfo}
          userContractRequest={userContractRequest}
          priorities={priorities}
          jobRecruitingFlag={jobRecruitingFlag}
          viewerType="user"
        />
      </Container>
    </>
  );
};

export default UserContractRequestPage;
